import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@rossum/ui/material';
import { useIntl } from 'react-intl';
import { boldText, white } from '../../../../lib/formaterValues';
import DialogTitle from '../../../../ui/dialog-title/DialogTitle';

export type ToggleAllDialogAction =
  | 'disableUsersOnQueue'
  | 'enableUsersOnQueue'
  | undefined;
type ToggleAllDialogProps = {
  action: ToggleAllDialogAction;
  queueName: string;
  count: number;
  onClose: () => void;
  onSubmit: () => void;
};
export const ToggleAllDialog = ({
  action,
  queueName,
  count,
  onClose,
  onSubmit,
}: ToggleAllDialogProps) => {
  const intl = useIntl();

  return (
    <Dialog
      open={!!action}
      PaperProps={{
        sx: { width: 480, minHeight: 220, position: 'fixed' },
        elevation: 2,
      }}
      onClose={onClose}
      sx={{ transition: 'smooth' }}
    >
      {action ? (
        <Stack>
          <DialogTitle
            title={intl.formatMessage({
              id: `components.modal.${action}.title`,
            })}
            onClose={onClose}
          />
          <DialogContent sx={{ mx: 4, mt: 4, p: 0 }}>
            <Typography variant="body1">
              {intl.formatMessage(
                {
                  id: `components.modal.${action}.text`,
                },
                { bold: boldText, white, count, queueName }
              )}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ pb: 4, pt: 2.5, mr: 4, pr: 0 }}>
            <Button
              variant="outlined"
              size="medium"
              color="secondary"
              onClick={onClose}
              data-cy="modal-cancel-button"
            >
              {intl.formatMessage({
                id: `components.modal.${action}.cancel`,
              })}
            </Button>
            <Button
              variant="contained"
              size="medium"
              color="primary"
              onClick={onSubmit}
              data-cy="modal-confirm-button"
            >
              {intl.formatMessage({
                id: `components.modal.${action}.confirm`,
              })}
            </Button>
          </DialogActions>
        </Stack>
      ) : null}
    </Dialog>
  );
};
